import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '@oneaudi/unified-web-components';
import { useState } from 'react';
import { Image, Placeholder } from './image-loader-style';
import { useCarlineStore } from '../../store/carline';
const ImageLoader = ({ src, alt }) => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const { compare } = useCarlineStore();
    const handleLoad = () => {
        setLoading(false);
    };
    const handleError = () => {
        setLoading(false);
        setError(true);
    };
    if (!src || error) {
        return (_jsx(Placeholder, { "$compare": compare, children: _jsx(Icon, { name: 'car', size: 'l' }) }));
    }
    return (_jsxs(_Fragment, { children: [loading && (_jsx(Placeholder, { "$compare": compare, children: _jsx(Icon, { name: 'car', size: 'l' }) })), _jsx(Image, { "$compare": compare, src: src, alt: alt, onLoad: handleLoad, onError: handleError, style: {
                    display: loading ? 'none' : 'block',
                }, "data-testid": "image" })] }));
};
export default ImageLoader;
